import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import { Link, useParams, withRouter, useHistory } from "react-router-dom";
import
{
  CardBody,
  Container,
  Row,
  Card,
  CardHeader,
  Spinner,
  Alert,
  Col,
  Modal,
  Form,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "reactstrap";


// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import BreadCrumb from "../../../../Components/Common/BreadCrumb";

import TableContainer from "../../../../Components/Common/TableContainer";
//Import actions
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../../axiosConfig";
import TakciLogo from "../../../../assets/images/logo-light.png";

//redux
import { useDispatch } from "react-redux";

import Loader from "../../../../Components/Common/Loader";
import Key from "../../../../key";


import moment from "moment";
import "moment/locale/fr";
import UpdateTicketModal from "../Components/UpdateTickets";
import { AfficherQR, QRCodeGenerator } from "./QrCode";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { lireRoleSession } from "../../../../espace";


moment.locale( "fr" );

const BilletDetail = ( props ) =>
{
  const history = useHistory();
  function formatDate ( date )
  {
    const dateObject = new Date( date ).toLocaleDateString( "fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric"
    } );
    return dateObject;
  }

  const { id: ticketId } = useParams();

  const [ roleSession, setRoleSession ] = useState( lireRoleSession )
  const [ idConnected, setIdConnected ] = useState( null )
  function getSessionData ()
  {
    if ( localStorage.getItem( "authUser" ) )
    {
      const obj = JSON.parse( localStorage.getItem( "authUser" ) );
      // console.log( 'obj localStorage:', obj )
      setRoleSession( obj.role )

      if ( obj.data )
      {
        setIdConnected( obj.data.id )
      }
    }
  }


  const ref = useRef( null );
  const [ loading, setLoading ] = useState( true );
  const [ selectTicket, setSelectTicket ] = useState( {} );

  const [ qrImage, setQrImage ] = useState( null );
  const [ dataTicketQR, setDataTicketQR ] = useState( {} );

  const fetchTicketData = useCallback( async () =>
  {
    try
    {
      const ticketDetailResponse = await axiosInstance.get(
        `/billetgetone/?billet_id=${ ticketId }/`
      );
      const ticketData = ticketDetailResponse.data.data;
      console.log( "ticketDetailResponse.data: ", ticketDetailResponse.data )
      setSelectTicket( ticketData );
      setDataTicketQR( {
        eventId: ticketData.event_id,
        billetId: ticketData.id,
      } )
    } catch ( err )
    {
      console.error( "Échec de récupération des données relatives au ticket. Erreur: ", err );
      toast.error( "Échec de récupération des données relatives au ticket." );
    }

    setLoading( false );
  }, [] ); // Add ticketId to the dependencies array



  useEffect( () =>
  {
    getSessionData()
    fetchTicketData();
  }, [] );



  const downloadPDF = () =>
  {
    const input = ref.current;
    html2canvas( input, { scale: 0.70, useCORS: true } )
      .then( ( canvas ) =>
      {
        const imgData = canvas.toDataURL( 'image/png' );
        const pdf = new jsPDF();
        pdf.addImage( imgData, 'PNG', 0, 0 );
        pdf.save( `ticket-${ selectTicket.evenement_nom || "evenement" }.pdf` );
      } ).catch( error =>
      {
        console.error( "Erreur lors de l'envoi :", error );
        toast.error( props.t( "Une erreur s'est produite" ), { autoClose: 3000 } );
      } );

  };

  document.title = props.t( "Détails du billet | Takci" );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Détails du ticket"
            pageTitle="Tickets"
          />
          { loading ? (
            <div className="text-center my-5">
              <Loader style={ { color: "#014c94" } } />
              <h2>Chargement...</h2>
            </div>
          ) : (
            <Row g={ 2 } className="my-2 g-2">
              <Col xxl={ 12 }>
                { Object.keys( selectTicket ).length > 0 ? (
                  <Row
                    ref={ ref }
                    className="d-flex align-items-center h-100 g-2"

                  >
                    <Col
                      xs={ 9 }
                      className="p-3 h-100"
                      style={ {
                        fontSize: "large",
                        backgroundColor: `${ selectTicket?.color_billet || "#011866" }`
                      } }
                    >
                      <div
                        className="mb-4"
                      >
                        <h1 className="text-light display-4" style={ {
                          fontWeight: "bolder",
                          fontSize: "150%",
                        } }>
                          { selectTicket.evenement_nom }
                        </h1>
                        <Row
                          className="justify-content-between"
                          style={ {
                            fontWeight: "initial",
                          } }
                        >
                          <Col className="d-flex align-items-center">
                            <i className="ri-calendar-event-fill"></i>:
                            <span
                              className="ms-1"
                              style={ {
                                fontSize: "60%",
                              } }
                            >
                              { selectTicket.evenement_date ? `${ ( moment( selectTicket.evenement_date ).format( "dddd D MMMM YYYY" ).charAt( 0 ) ).toUpperCase() }${ moment( selectTicket.evenement_date ).format( "dddd D MMMM YYYY" ).substring( 1 ) }` : "" }
                            </span>
                          </Col>
                          <Col
                            className="d-flex align-items-center"
                            style={ {
                              fontSize: "60%",
                            } }
                          >
                            <i className="ri-alarm-fill"></i>:
                            <span className="ms-1">
                              { moment( selectTicket.evenement_heure, "HH:mm:ss" ).format( `HH:mm` ) }

                            </span>
                          </Col>
                        </Row>
                        {
                          moment( selectTicket.evenement_date ).format( "dddd D MMMM YYYY" ) !== moment( selectTicket.evenement_date_fin ).format( "dddd D MMMM YYYY" )
                          &&
                          <Row
                            className="justify-content-between"
                            style={ {
                              fontWeight: "initial",
                              fontSize: "60%",
                            } }
                          >
                            <span className="ms-5">
                              au
                            </span>
                            <Col
                              xs={ 12 }
                              className="d-flex align-items-center"

                            >
                              <i className="ri-calendar-2-fill"></i>:
                              <span
                                className="ms-1"
                              >
                                { selectTicket.evenement_date_fin ? `${ ( moment( selectTicket.evenement_date_fin ).format( "dddd D MMMM YYYY" ).charAt( 0 ) ).toUpperCase() }${ moment( selectTicket.evenement_date_fin ).format( "dddd D MMMM YYYY" ).substring( 1 ) }` : "" }
                              </span>
                            </Col>
                          </Row>
                        }
                        <div
                          className="d-flex align-items-center"
                          style={ {
                            fontWeight: "initial",
                            fontSize: "60%",
                          } }
                        >
                          <i className="ri-map-pin-fill"></i>:
                          <span className="ms-1">
                            { selectTicket.evenement_lieu ? `${ ( selectTicket.evenement_lieu.charAt( 0 ) ).toUpperCase() }${ ( selectTicket.evenement_lieu.substring( 1 ) ) }` : "" }

                          </span>
                        </div>
                      </div>

                      <div className="justify-content-between"
                        style={ {
                          fontSize: "60%",
                        } }
                      >
                        { `${ selectTicket.categorie ? `${ ( selectTicket.categorie.charAt( 0 ) ).toUpperCase() }${ ( selectTicket.categorie.substring( 1 ) ) }` : "" }: ${ selectTicket.montant } XOF` }
                      </div>
                    </Col>
                    <Col
                      xs={ 3 }
                      className="h-100 justify-items-center border-2"
                      style={ {
                        flex: 1,
                        // backgroundColor: "#fff",
                        borderWidth: 2,
                      } }
                    >
                      <div
                        className="h-100 w-100 align-content-center justify-items-center"
                      >
                        <div className="text-center  align-content-center justify-items-center"
                          style={ {
                            flex: 1,
                            borderWidth: 2,
                            borderColor: "red",
                          } }
                        >
                          <QRCodeGenerator data={ dataTicketQR } setQrImage={ setQrImage } />
                          { qrImage &&
                            <AfficherQR qrImage={ qrImage }
                              style={ {
                                width: "60%",
                                height: "100%"
                              } }
                            />
                          }
                          <span
                            className="text-primary fw-bold"
                            style={ {
                              fontSize: "60%",
                            } }
                          >
                            Réalisé par TAKCI
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <Alert color="warning" className="text-center">
                    Aucune information sur le ticket disponible.
                  </Alert>
                ) }

              </Col>
              {
                !loading && Object.keys( selectTicket ).length > 0 &&
                <div className="text-center">
                  <Button to="#" onClick={ downloadPDF } className="btn btn-primary">
                    <i className="ri-download-2-line align-bottom me-1"></i>{ " " }
                    { props.t( "Télécharger" ) }
                  </Button>
                </div>
              }

              {/* <Col xxl={ 9 }>
                <Card className="w-100 h-100">
                  {
                    loadingTicket ?
                      <div className="d-flex text-center">
                        <Spinner size={ "lg" } />
                        <span className="ms-1">Chargement...</span>
                      </div>
                      :
                      <Card>
                        <CardHeader className="fw-bold d-flex justify-content-between">
                          Liste des Tickets
                          {
                            roleSession === "ORGANISATEUR" &&
                            <button
                              onClick={ () =>
                                setModalAddTicket( true )
                              }
                              className="btn btn-outline-primary d-flex"
                            >
                              <i className="ri-add align-bottom"></i>
                              <span className="ms-1">
                                Ajouter un ticket
                              </span>
                            </button>
                          }
                        </CardHeader>
                        <CardBody>
                          {

                            billetTicket.length > 0 ?
                              <div className="table-card grid js-border-none pb-2">
                                <TableContainer
                                  columns={ columnsTable }
                                  data={ billetTicket || [] }
                                  isGlobalFilter={ false }
                                  isAddUserList={ false }
                                  customPageSize={ 10 }
                                  divClass="table-responsive"
                                  tableClass="mb-0 table-borderless"
                                  theadClass="table-light text-muted"
                                />
                              </div>
                              : (
                                <Alert color="warning">Aucun ticket disponible.</Alert>
                              )
                          }
                        </CardBody>
                      </Card>
                  }
                </Card>
              </Col> */}
            </Row>
          ) }
          <ToastContainer closeButton={ false } />
        </Container>
      </div>

    </React.Fragment>
  );
};

BilletDetail.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter( withTranslation()( BilletDetail ) );
